import { Component, OnInit, inject } from '@angular/core';
import * as VirtualSwitchesActions from './../../../../app/@store/virtual_switches/virtual_switches.actions';
import * as VirtualSwitchesSelectors from './../../../../app/@store/virtual_switches/virtual_switches.selectors';
import * as BreakoutActions from './../../../../app/@store/breakouts/breakouts.actions';
import * as BreakoutSelectors from './../../../../app/@store/breakouts/breakouts.selectors';
import * as LinksActions from './../../../../app/@store/links/links.actions';
import * as LinksSelectors from './../../../../app/@store/links/links.selectors';
import { Store } from '@ngrx/store';
import { filter, map, first } from 'rxjs/operators';
import * as _ from 'lodash';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { getPartenrDefaultLocationUuid } from './../../../../app/@store/partner/partner.selectors';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { PageHeaderModule } from '@gridscale/ingrid/components/page-header';
import { LocalstorageService } from '@gridscale/gs-services/localstorage.service';
import { LocationSelectDropdownComponent } from '../_location-select-dropdown/location-select-dropdown.component';
import { NavigationSubMenuTabsComponent } from '../../_navigation/_sub-menu-tabs/sub-menu-tabs.component';

export const SDN_DEFAULT_LOCATION_STORAGE_KEY = 'sdn_location2';

@Component({
    imports: [
        CommonModule,
        FormsModule,
        LocationSelectDropdownComponent,
        PageHeaderModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        NavigationSubMenuTabsComponent
    ],
    selector: 'app-sdn',
    templateUrl: './sdn.component.html',
    styleUrls: ['./sdn.component.scss']
})
export class SdnComponent implements OnInit {
  selectedLocation?: string;
  locationSelectForm = this.fb.group({
    default_location_uuid: ['']
  });


  getVirtualSwitchesCount$ = this.store.select(VirtualSwitchesSelectors.getVirtualSwitchesMeta).pipe(
    filter(meta => meta !== undefined),
    map(meta => meta!.total)
  );
  getBreakoutsCount$ = this.store.select(BreakoutSelectors.getBreakoutsMeta).pipe(
    filter(meta => meta !== undefined),
    map(meta => meta!.total)
  );

  getLinkCount$ = this.store.select(LinksSelectors.getLinksMeta).pipe(
    map(meta => meta?.total)
  );

  private selectedLocationSet = false;

  readonly #translate = inject(TranslateService);

  constructor(
    private readonly store: Store,
    private localStorage: LocalstorageService,
    private readonly fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {

    this.getDefaultLocation();
  }

  onUpdateSelectedLocation(selectedLocation: string) {
    this.selectedLocation = selectedLocation;
    if (this.selectedLocation) {
      this.localStorage.setItem(SDN_DEFAULT_LOCATION_STORAGE_KEY, this.selectedLocation);
    }
    this.store.dispatch(VirtualSwitchesActions.loadVirtualSwitches());
    this.store.dispatch(BreakoutActions.loadBreakouts());
    this.store.dispatch(LinksActions.loadLinks());
  }

  getDefaultLocation() {
    if (!this.selectedLocationSet) {
      const loc = this.localStorage.getItem(SDN_DEFAULT_LOCATION_STORAGE_KEY);

      if (loc) {
        this.onUpdateSelectedLocation(loc);
      } else {
        this.store
          .select(getPartenrDefaultLocationUuid)
          .pipe(
            first(),
            filter(locationUuid => locationUuid !== undefined && locationUuid !== '' && locationUuid !== null)
          )
          .subscribe(locationUuid => {
            this.localStorage.setItem(SDN_DEFAULT_LOCATION_STORAGE_KEY, locationUuid);
            this.onUpdateSelectedLocation(locationUuid);
          });
      }



      this.selectedLocationSet = true;
    }
  }

  get currentLang(): string {
    return this.#translate.currentLang;
  }
}

